import React from "react";
import { useHistory } from "react-router-dom";
import CardPage from "../../layout/CardPage";
import { Card, Col, Row } from "antd";
import { blue } from "@ant-design/colors";
import {
  CarOutlined,
  TeamOutlined,
  AlertOutlined,
  FormOutlined,
  PhoneOutlined,
  DashboardOutlined,
} from "@ant-design/icons";

const items = [
  { label: "Semáforo fase 1", icon: <FormOutlined />, path: "/semaforoFase1" },
  { label: "Semáforo fase 2", icon: <PhoneOutlined />, path: "/semaforoFase2" },
  { label: "Semáforo Asignación", icon: <DashboardOutlined />, path: "/semaforoAsignacionMonitor" },
  { label: "Asignación", icon: <TeamOutlined />, path: "/semaforoAsignacion" },
  { label: "Escalamiento", icon: <AlertOutlined />, path: "/semaforoEscalamiento" },
  { label: "Seguimiento", icon: <CarOutlined />, path: "/semaforoSeguimiento" },
];

export const SemaforoHome = () => {
  const history = useHistory();

  return (
    <CardPage titulo="Semáforos">
      <Row gutter={[16, 16]}>
        {items.map((item) => (
          <Col xs={12} md={8} xl={6} xxl={4} key={item.path}>
            <Card
              hoverable
              onClick={() => history.push(item.path)}
              style={{ textAlign: "center", borderRadius: 12, borderColor: blue.primary }}
              bodyStyle={{ padding: "14px 10px" }}
            >
              <div style={{ fontSize: 28, color: blue.primary, marginBottom: 4 }}>
                {item.icon}
              </div>
              <div style={{ fontSize: 18, fontWeight: 600 }}>{item.label}</div>
            </Card>
          </Col>
        ))}
      </Row>
    </CardPage>
  );
};
